/*
 * Module for the DirectDeposit/Index view
*/

rs.module("ui/content/benefits/directdeposit/index",

    [
        "controls/components/event-banner"
    ],

    function (eventBanner) {

        // Initialize the module
        function initialize(jsSelectors, backendUrls, filterOptions) {

            // Unpack js selectors
            var filterSelect = $.js(jsSelectors.filterSelect);
            var directDeposit = $.js(jsSelectors.directDeposit);
            var skeleton = $.js(jsSelectors.skeleton);

            // Update the list based on selected filter
            filterSelect.change(function () {
                eventBanner.removeAllMessages();
                skeleton.show();
                directDeposit.hide();

                var showAll = $(this).val() == filterOptions.all;
                $.get(
                    backendUrls.getDirectDeposits,
                    {
                        showAll: showAll
                    })
                    .done(function (html) {
                        directDeposit.html(html);
                    })
                    .always(function () {
                        skeleton.hide();
                        directDeposit.show();
                    });
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);